(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["paam-home"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.heading-row').forEach(function(h){var r=h.parentElement.querySelector('[data-rail]');if(!r)return;function m(d){r.scrollBy({left:d*r.clientWidth*.86,behavior:'smooth'})}h.querySelector('[data-prev]')?.addEventListener('click',function(){m(-1)});h.querySelector('[data-next]')?.addEventListener('click',function(){m(1)})});
  } catch(e) { console.error(e); }
})();
})();
